"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropdownItem = void 0;
// packages
const react_1 = __importStar(require("react"));
// styles
const DropdownItem_styles_1 = require("./DropdownItem.styles");
const Dropdown_styles_1 = require("./Dropdown.styles");
const Tooltip_1 = require("../Tooltip/Tooltip");
const StyledDropdownItem = (props) => {
    var _a, _b, _c;
    const firstLabelRef = (0, react_1.useRef)(null);
    const secondLabelRef = (0, react_1.useRef)(null);
    const thirdLabelRef = (0, react_1.useRef)(null);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (firstLabelRef.current && secondLabelRef.current) {
            setShowTooltip(firstLabelRef.current.offsetWidth < firstLabelRef.current.scrollWidth ||
                secondLabelRef.current.offsetWidth <
                    secondLabelRef.current.scrollWidth);
        }
    }, [firstLabelRef]);
    const getConfigPerColumn = (index) => {
        const { config, option } = props;
        switch (index) {
            case 1:
                return {
                    ref: firstLabelRef,
                    label: option.firstColumn,
                    width: (config === null || config === void 0 ? void 0 : config.firstColumnWidth) || Dropdown_styles_1.ITEM_LEFT_WIDTH,
                };
            case 2:
                return {
                    ref: secondLabelRef,
                    label: option.secondColumn,
                    width: (config === null || config === void 0 ? void 0 : config.secondColumnWidth) || Dropdown_styles_1.ITEM_CENTER_WIDTH,
                };
            case 3:
                return {
                    ref: thirdLabelRef,
                    label: option.thirdColumn,
                    width: (config === null || config === void 0 ? void 0 : config.thirdColumnWidth) || Dropdown_styles_1.ITEM_RIGHT_WIDTH,
                };
            case 4:
                return {
                    ref: thirdLabelRef,
                    label: option.forthColumn,
                    width: (config === null || config === void 0 ? void 0 : config.fourthColumnWidth) || Dropdown_styles_1.ITEM_RIGHT_WIDTH,
                };
            default:
                return {
                    ref: firstLabelRef,
                    label: option.firstColumn,
                    width: (config === null || config === void 0 ? void 0 : config.firstColumnWidth) || Dropdown_styles_1.ITEM_LEFT_WIDTH,
                };
        }
    };
    const numberOfColumns = (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.numberOfColumns) !== null && _b !== void 0 ? _b : 3;
    const columnsToShow = [...Array(numberOfColumns).keys()].map((_, index) => {
        const config = getConfigPerColumn(index + 1);
        return (react_1.default.createElement(DropdownItem_styles_1.StyledItemLabel, { key: config.label, height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: config.width, paddingLeft: Dropdown_styles_1.ITEM_PADDING_LEFT },
            react_1.default.createElement(DropdownItem_styles_1.StyledItemText, { ref: config.ref, height: Dropdown_styles_1.ITEM_HEIGHT_TEXT, width: '100%' }, config.label)));
    });
    const Item = (react_1.default.createElement(DropdownItem_styles_1.StyledItemContainer, null,
        react_1.default.createElement(DropdownItem_styles_1.StyledItemElement, { "data-testid": "dropdown-item", isHovered: props.isHovered, isSelected: props.isSelected, onClick: props.onClick }, columnsToShow.map((column) => column))));
    if (!showTooltip) {
        return Item;
    }
    return (react_1.default.createElement(Tooltip_1.Tooltip, { title: props.format(props.option, ((_c = props.config) === null || _c === void 0 ? void 0 : _c.numberOfColumns) || 3), key: props.option.secondColumn }, Item));
};
exports.StyledDropdownItem = StyledDropdownItem;
exports.default = exports.StyledDropdownItem;
//# sourceMappingURL=DropdownItem.js.map